<template>
    <div class="order-filter" v-show="visible">
        <header class="app-header">
            <van-icon
                    @click="goBack"
                    class="back-icon"
                    size="0.5rem"
                    color="#fff"
                    name="arrow-left"
            />
            <h1 class="app-header-title">{{ title }}</h1>
        </header>
        <van-cell-group>
            <van-cell title="开始时间：" is-link @click="toggle('time',1)" :value="startTime"></van-cell>
            <van-cell title="结束时间：" is-link @click="toggle('time',2)" :value="endTime"></van-cell>
            <van-cell title="目的站：" v-if="type!=='tracking'" is-link @click="toggle('endOrgan')"
                      :value="endOrgan"></van-cell>
            <van-field label="目的站：" v-if="type==='tracking'" placeholder="请输入目的站"
                       v-model="filterKey.endOrganName"></van-field>
            <van-field label="订单号：" placeholder="请输入订单号" v-model="filterKey.orderNumber"></van-field>
            <van-field label="运单号：" placeholder="请输入运单号" v-model="filterKey.trackingNumber"></van-field>
            <van-field label="拉包工：" v-if="type!=='tracking'" placeholder="请输入拉包工"
                       v-model="filterKey.pullPackWorkerName"></van-field>
            <van-field label="拉包工电话：" v-if="type!=='tracking'" placeholder="请输入拉包工电话"
                       v-model="filterKey.concatPhone"></van-field>
            <van-field label="收货人：" placeholder="请输入收货人" v-model="filterKey.consigneeName"></van-field>
            <van-field label="收货人电话：" placeholder="请输入收货人电话" v-model="filterKey.consigneePhone"></van-field>
<!--            <van-cell title="订单状态：" is-link @click="toggle('status')" :value="status"></van-cell>-->
        </van-cell-group>
        <div class="btn">
            <van-button class="btn-spacing-4" @click="confirmFilter" type="warning" size="large">确定</van-button>
            <van-button class="btn-spacing-4" @click="resetFilter" type="danger" size="large">重置</van-button>
        </div>
        <!-- 时间选择器 -->
        <van-popup position="bottom" v-model="show.time">
            <van-datetime-picker @confirm="confirmTime" @cancel="toggle('time')" type="date" v-model="currentDate"
                                 :min-date="minDate" :max-date="maxDate"></van-datetime-picker>
        </van-popup>
        <!-- 物流公司选择器 -->
        <van-popup class="company-popup" position="bottom" v-model="show.company">
            <van-cell title="输入条件">
                <van-button @click="emptyCompany" type="danger" size="mini">清空</van-button>
            </van-cell>
            <van-search placeholder="输入网点名以查询数据" v-model="searchKey"></van-search>
            <div class="company-list">
                <van-cell @click="selCompany(index)" class="company-item" v-for="(item,index) in companyList"
                          :key="item.id"
                          v-show="item.show">
                    <div :class="{'company-name':true,active:item.active}" slot="title">{{item.logisticsCompanyName}}
                    </div>
                </van-cell>
            </div>
        </van-popup>
        <!-- 目的站选择器 -->
        <van-popup position="bottom" v-model="show.endOrgan">
            <van-area :area-list="areaList" :value="areaId.toString()" @cancel="cancelArea" @confirm="confirmArea"
                      columns-num="2"/>
        </van-popup>
<!--         订单状态选择器-->
        <van-popup position="bottom" v-model="show.status">
            <van-panel class="status-panel" title="订单状态">
                <ul class="status-list">
                    <li v-for="item in $store.state.dict.status" :key="item.dictValue"
                        :class="{'status-item':true,active:statusCheck[item.dictValue]}"
                        @click="selStatus(item.dictValue)">
                        {{item.name}}
                    </li>
                </ul>
                <div class="status-footer" slot="footer">
                    <div class="btn">
                        <van-button @click="emptyStatus" size="small">清空</van-button>
                        <van-button @click="confirmStatus" size="small" type="warning">确定</van-button>
                    </div>
                </div>
            </van-panel>
        </van-popup>
    </div>
</template>

<script>
    import {city} from "../../../utils/city.js";
    import {Dialog} from "vant";

    export default {
        name: "OrderFilter",
        props: {
            title: {
                type: String
            },
            type: {
                type: String
            },
            isNeedRefresh: {
                type: Boolean
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                companyName: "",
                endOrgan: "",
                startTime: "",
                endTime: "",
                status: "",
                filterKey: {
                    orderNumber: "",
                    trackingNumber: "",
                    pullPackWorkerName: "",
                    concatPhone: "",
                    consigneeName: "",
                    consigneePhone: "",
                    consigneeCityCode: "",
                    status: "",
                    logisticsCompanyId: this.$logisticsCompanyId,
                    startTime: "",
                    endTime: "",
                    endOrganName: ""
                },
                show: {
                    company: false,
                    time: false,
                    endOrgan: false,
                    status: false
                },
                timeType: 1,
                minDate: "",
                maxDate: "",
                currentDate: new Date(),
                companyList: [],
                areaList: city,
                areaId: "440106",
                statusCheck: [],
                searchKey: ""
            };
        },
        created() {
            this.ready();
        },
        watch: {
            searchKey(newVal) {
                this.companyList.forEach(val => {
                    if (val.logisticsCompanyName.indexOf(newVal) !== -1) {
                        val.show = true;
                    } else {
                        val.show = false;
                    }
                });
            },
            isNeedRefresh(newVal) {
                if (newVal) {
                    this.resetFilter();
                    this.$emit("refresh");
                }
            }
        },
        methods: {
            goBack() {
                this.$emit('update:visible', false)
            },
            ready() {
                this.$axios.post("worker/getOrganizationList").then(res => {
                    if (res.data.code === 200) {
                        res.data.data.forEach(val => {
                            val.show = true;
                        });
                        this.companyList = res.data.data;
                    }
                });
            },
            toggle(flag, type) {
                this.show[flag] = !this.show[flag];
                if (type) {
                    this.timeType = type;
                    this.minDate = new Date(new Date().getFullYear() - 4, 0, 1);
                    this.maxDate = new Date();
                }
                if (flag === "status") {
                    this.statusCheck.forEach((value, i) => {
                        this.$set(this.statusCheck, i, false);
                    });
                    if (this.filterKey.status) {
                        this.filterKey.status.split(",").forEach(value => {
                            this.statusCheck[value] = true;
                        });
                    }
                }
            },
            dateFormat(d) {
                let year = d.getFullYear();
                let month = d.getMonth() + 1;
                let date = d.getDate();
                month = month < 10 ? "0" + month : month;
                date = date < 10 ? "0" + date : date;
                return year + "-" + month + "-" + date;
            },
            confirmTime(value) {
                if (this.timeType === 1) {
                    this.startTime = this.dateFormat(value);
                    this.filterKey.startTime = this.dateFormat(value) + " 00:00:00";
                } else {
                    this.endTime = this.dateFormat(value);
                    this.filterKey.endTime = this.dateFormat(value) + " 23:59:59";
                }
                this.show.time = false;
            },
            cancelArea() {
                this.endOrgan = "";
                this.filterKey.consigneeCityCode = "";
                this.show.endOrgan = false;
            },
            confirmArea(v) {
                this.endOrgan = v[0].name + "-" + v[1].name;
                this.filterKey.consigneeCityCode = v[1].code;
                this.show.endOrgan = false;
            },
            emptyCompany() {
                this.companyList.forEach(val => {
                    this.$set(val, "active", false);
                });
                this.searchKey = "";
                this.companyName = "";
                this.filterKey.logisticsCompanyId = this.$logisticsCompanyId;
                this.show.company = false;
            },
            selCompany(i) {
                this.companyName = this.companyList[i].logisticsCompanyName;
                this.filterKey.logisticsCompanyId = this.companyList[
                    i
                    ].logisticsCompanyId;
                this.companyList.forEach((value, index) => {
                    this.$set(this.companyList[index], "active", false);
                });
                this.$set(this.companyList[i], "active", true);
                this.searchKey = "";
                this.show.company = false;
            },
            selStatus(i) {
                if (this.statusCheck[i]) {
                    this.$set(this.statusCheck, i, false);
                } else {
                    this.$set(this.statusCheck, i, true);
                }
            },
            emptyStatus() {
                this.companyList.forEach(val => {
                    this.$set(val, "active", false);
                });
                this.searchKey = "";
                this.filterKey.status = "";
                this.status = "";
                this.show.status = false;
            },
            confirmStatus() {
                let status = [];
                let statusText = [];
                this.statusCheck.forEach((value, i) => {
                    if (value) {
                        status.push(i);
                        this.$store.state.dict.status.forEach(v => {
                            if (v.dictValue.toString() === i.toString()) {
                                statusText.push(v.name);
                            }
                        });
                    }
                });
                this.filterKey.status = status.join(",");
                this.status = statusText.join(",");
                this.show.status = false;
            },
            resetFilter() {
                Object.keys(this.filterKey).forEach(key => {
                    this.filterKey[key] = "";
                });
                this.filterKey.logisticsCompanyId = this.$logisticsCompanyId;
                this.companyName = this.endOrgan = this.startTime = this.endTime = this.status =
                    "";
                this.companyList.forEach(val => {
                    val.active = false;
                });
                this.statusCheck.splice(0, this.statusCheck.length - 1);
            },
            confirmFilter() {
                let startTime = new Date(this.startTime);
                let endTime = new Date(this.endTime);
                if (startTime > endTime) {
                    Dialog.alert({
                        title: "温馨提示",
                        message: "请选择正确的时间段！"
                    }).then(() => {
                        return false;
                    });
                    return false;
                }
                this.$emit("confirm", this.filterKey);
            }
        }
    };
</script>

<style lang="scss">
    .order-filter {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
    }

    .company-popup {
        font-weight: normal;
        font-size: 0.35rem;
        color: #000;
        border-radius: 5px 5px 0 0;

        .van-icon {
            transform: translateY(3px);
        }

        .company-list {
            max-height: 7rem;
            overflow-y: scroll;

            .company-item {
                text-align: center;
                font-size: 0.4rem;
                padding: 0.2rem;

                .active {
                    background-color: #ccc;
                    border-radius: 5px;
                }

                .company-name {
                    padding: 0.25rem 0;
                }
            }
        }
    }

    .status-list {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;

        .status-item {
            float: left;
            width: 30%;
            text-align: center;
            padding: 0.25rem;
            margin: 0.125rem 0;
            box-sizing: border-box;
            background-color: #ddd;

            &.active {
                background-color: #0b92e6;
                color: #fff;
            }
        }
    }

    .status-footer {
        .btn {
            text-align: right;

            .van-button {
                margin: 0;
                margin-left: 0.25rem;
            }
        }
    }

    .btn {
        padding: 0 0.25rem;

        .van-button {
            margin-top: 0.25rem;
        }
    }
    .arrow_left{
        position: absolute;
        top: .5rem;
        font-size: 16px;
        color: #fff;
    }
</style>
